import { Anlagentyp } from './anlagentyp';
import { Netzzuordnung } from './netzzuordnung';

export class Erzeugungsanlage {
    public id: string;
    public version: number;
    public westnetzId: string;
    public installierteLeistungKW: number;
    public anlagentyp: Anlagentyp;
    public netzzuordnung: Netzzuordnung;
    public abregelbareLeistungKW: number;
}
